import { Accordion } from './accordion';
import { Avatar } from './avatar';
import { Button } from './button';
import { Card } from './card';
import { Checkbox } from './checkbox';
import { Input } from './input';
import { Link } from './link';
import { Progress } from './progress';
import { Radio } from './radio';
import { Select } from './select';
import { Table } from './table';
import { Tabs } from './tabs';
import { Text } from './text';
import { Textarea } from './textarea';
import { tagTheme as Tag } from '../../components/tag';
export default {
    Accordion,
    Avatar,
    Button,
    Card,
    Checkbox,
    Input,
    Link,
    Progress,
    Radio,
    Select,
    Table,
    Tabs,
    Tag,
    Text,
    Textarea
};

//# sourceMappingURL=index.js.map